import { z } from 'zod';
export const MailProvider = z.enum(['google', 'microsoft', 'imap']);
export const MailStatus = z.enum(['pending_assignment', 'assigned', 'ignored']);
export const mailAccount = z.object({
    id: z.number().int().positive(),
    userId: z.number().int().positive(),
    provider: MailProvider,
    address: z.string().email(),
    displayName: z.string().nullable().optional(),
    imapHost: z.string().nullable().optional(),
    imapPort: z.number().int().nullable().optional(),
    imapUser: z.string().nullable().optional(),
    active: z.boolean().default(true),
    lastSyncAt: z.string().datetime().nullable().optional(),
    syncStatus: z.string().nullable().optional(),
    createdAt: z.string().datetime(),
});
export const createMailAccountRequest = z
    .object({
    provider: MailProvider.default('imap'),
    address: z.string().email(),
    displayName: z.string().min(1).max(120).optional(),
    imapHost: z.string().min(1).max(255),
    imapPort: z.number().int().positive().default(993),
    imapUser: z.string().min(1).max(255),
    imapPassword: z.string().min(1).max(255),
})
    .strict();
export const mailAccountListResponse = z.object({
    items: z.array(mailAccount),
});
export const mailMessage = z.object({
    id: z.number().int().positive(),
    accountId: z.number().int().positive(),
    remoteId: z.string(),
    fromAddress: z.string(),
    fromName: z.string().nullable().optional(),
    toAddresses: z.array(z.string()),
    subject: z.string(),
    receivedAt: z.string().datetime(),
    bodyText: z.string().nullable().optional(),
    bodyHtml: z.string().nullable().optional(),
    attachments: z
        .array(z.object({
        filename: z.string(),
        contentType: z.string(),
        size: z.number().int().nonnegative(),
    }))
        .nullable()
        .optional(),
    suggestedProjectId: z.number().int().positive().nullable().optional(),
    suggestedConfidence: z.number().int().min(0).max(100).nullable().optional(),
    status: MailStatus,
    assignedProjectId: z.number().int().positive().nullable().optional(),
    assignedAt: z.string().datetime().nullable().optional(),
});
export const assignMailRequest = z.object({
    projectId: z.number().int().positive(),
    /**
     * Optionaler Behördenvorgang, zu dem diese Nachricht gehört. Ist er gesetzt,
     * wird die Mail als eingegangene Korrespondenz an den Vorgang gehängt — erst
     * damit ist der Schriftwechsel im System vollständig statt nur die eigene
     * Einreichung.
     */
    vorgangId: z.number().int().positive().optional(),
});
export const mailListResponse = z.object({
    items: z.array(mailMessage),
    total: z.number().int().nonnegative(),
});
